module.exports = __webpack_public_path__ + "static/img/8.bce3d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8.jpg
// module id = of7W
// module chunks = 26